import { useEffect, useState, useRef } from "react";
import KeyPanel from "./KeyPanel";

interface StickyKeyPanelProps {
  handleAddKey: () => void;
  keys: any[];
}

export default function StickyKeyPanel({ keys, handleAddKey }: StickyKeyPanelProps) {
  const [showSticky, setShowSticky] = useState(false);
  const keyPanelRef = useRef<HTMLDivElement | null>(null);

  // Efekt do zarządzania klasą na body (dla paddingu) - zostawiamy, przyda się
  useEffect(() => {
    const scrollableContainer = document.body; 
    
    if (showSticky) {
      scrollableContainer.classList.add("body--sticky-panel-active");
    } else {
      scrollableContainer.classList.remove("body--sticky-panel-active");
    }

    return () => {
      scrollableContainer.classList.remove("body--sticky-panel-active");
    };
  }, [showSticky]);

  // Główny efekt do logiki IntersectionObserver
  useEffect(() => {
    // Krok 1: Sprawdzamy wszystkie elementy, które wpływają na logikę
    const permissionTable = document.querySelector(".permission-table-row");
    const keyTable = document.querySelector(".key-table");
    const lockButtons = document.querySelector(".LockConfiguratorButonsXD") as HTMLDivElement | null;
    // <-- ZMIANA: Dodajemy selektor dla description-wrapper
    const descriptionWrapper = document.querySelector(".description-wrapper") as HTMLDivElement | null;
    const keyPanelElement = keyPanelRef.current;

    if (!permissionTable || !keyTable || !keyPanelElement) {
      return;
    }

    // Proste zmienne do śledzenia stanu widoczności wszystkich trzech elementów
    let isKeyPanelVisible = true;
    let areLockButtonsVisible = false;
    // <-- ZMIANA: Dodajemy zmienną dla description-wrapper
    let isDescriptionWrapperVisible = false; 

    const updateStickyState = () => {
      // <-- ZMIANA: Aktualizujemy warunek końcowy o trzeci element
      const shouldShow = !isKeyPanelVisible && !areLockButtonsVisible && !isDescriptionWrapperVisible;
      setShowSticky(shouldShow);
    };

    // Obserwator nr 1: Śledzi widoczność KeyPanel (bez zmian)
    const keyPanelObserver = new IntersectionObserver(
      ([entry]) => {
        isKeyPanelVisible = entry.isIntersecting;
        updateStickyState();
      },
      { root: null, threshold: 0, rootMargin: "0px 0px -20px 0px" }
    );

    // Obserwator nr 2: Śledzi widoczność przycisków blokujących (bez zmian)
    let lockButtonsObserver: IntersectionObserver | null = null;
    if (lockButtons) {
      lockButtonsObserver = new IntersectionObserver(
        ([entry]) => {
          areLockButtonsVisible = entry.isIntersecting;
          updateStickyState();
        },
        { root: null, threshold: 0 }
      );
      lockButtonsObserver.observe(lockButtons);
    }

    // <-- ZMIANA: Dodajemy Obserwator nr 3 dla description-wrapper
    let descriptionWrapperObserver: IntersectionObserver | null = null;
    if (descriptionWrapper) {
      descriptionWrapperObserver = new IntersectionObserver(
        ([entry]) => {
          isDescriptionWrapperVisible = entry.isIntersecting;
          updateStickyState();
        },
        { root: null, threshold: 0 }
      );
      descriptionWrapperObserver.observe(descriptionWrapper);
    }


    keyPanelObserver.observe(keyPanelElement);

    // Funkcja czyszcząca
    return () => {
      keyPanelObserver.disconnect();
      if (lockButtonsObserver) {
        lockButtonsObserver.disconnect();
      }
      // <-- ZMIANA: Dodajemy czyszczenie dla nowego obserwatora
      if (descriptionWrapperObserver) {
        descriptionWrapperObserver.disconnect();
      }
    };
  }, []);

  return (
    <>
      <div ref={keyPanelRef}>
        <KeyPanel handleAddKey={handleAddKey} />
      </div>

      <div
        className="sticky-key-panel"
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          right: 0,
          width: "50px",
          background: "transparent",
          boxShadow: "none",
          zIndex: 100,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px 8px",
          animation: "fadeIn 0.3s ease-out",
          borderLeft: "none",
          opacity: showSticky ? 1 : 0,
          pointerEvents: showSticky ? 'auto' : 'none',
          transition: "opacity 0.3s ease-out",
        }}
      >
        <button
          onClick={handleAddKey}
          style={{
            backgroundColor: "#005ca9",
            color: "white",
            border: "none",
            width: "200px",
            borderRadius: "25px",
            // margines pochodził wcześniej z CSS panelu admina (reguła "button" bez zakresu)
            margin: "4px",
            padding: "8px 15px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontSize: "14px",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            transform: "rotate(270deg)",
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#004080"}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#005ca9"}
        >
          Schlüssel hinzufügen
          <img
            src="/img/configurator/plus.svg"
            alt="plus"
            style={{ width: "18px", height: "18px", filter: "brightness(0) invert(1)" }}
          />
        </button>
      </div>
    </>
  );
}